import { object, string, null as zNull } from "zod/v4";

export const retryItemReceiptEvent = {
  name: "retryItemReceiptEvent" as const,
  input: object({ returnId: string(), itemReceiptId: string() }),
  output: zNull(),
};
